import { identify, makeRequest, Service } from '../../../utils/http';

export async function getWorkspaceClientsApi() {
  return makeRequest(Service.getWorkspaceClients(await identify()));
}
